import React from 'react';

// DEPENDENCIES
import { createPortal } from 'react-dom';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions.js';

// HOOKS
import { useRecordContext } from 'helpers/getRecordData';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Sidebar from 'parts/sidebar/Sidebar';

// VARIABLES
export const CONVERT_REASON_OPTIONS = [
  {
    label: 'Mileage is over limit',
    value: 1
  },
  {
    label: 'Age of vehicle',
    value: 2
  },
  {
    label: 'Other',
    value: 3
  }
];

// MAIN COMPONENT
const ConvertSidebar = () => {
  
  // REACT ROUTER
  const { recordID } = useParams();

  // HOOKS
  const { record: { stock_num } = {}, refetchRecord } = useRecordContext() || {};

  // RENDER
  return createPortal(
    <Sidebar name="convertSidebar" title="Convert to Pre-Owned">
      <Sidebar.Form
        method="PUT"
        endpoint={ENDPOINTS.inventory.convert}
        initialValues={{
          dailysalesinventoryid: recordID,
          convertreasonid: CONVERT_REASON_OPTIONS[1].value
        }}
        loadingMessage={`Converting stock # ${stock_num}`}
        successMessage={`Stock # ${stock_num} has been converted`}
        errorMessage={`Failed to convert stock # ${stock_num}`}
        onSuccess={() => {
          doCallback(refetchRecord);
        }}
      >
        <Form.Text><big>What is the reason you're converting the vehicle?</big></Form.Text>
        <Form.Select name="convertreasonid" label="Reason" options={CONVERT_REASON_OPTIONS} required />
        <Form.Control name="convertreasoncomment" label="Comment" required />
        <Form.Control
          label="Stock #"
          value={stock_num}
          plaintext
        />
        <Form.Control
          name="stocknum"
          label="Confirm Stock #"
          validationSchema={yup.string().required('Please confirm').oneOf([stock_num, ''], 'Confirmation does not match')}
        />
      </Sidebar.Form>
    </Sidebar>,
    document.body
  );
};
const ConvertSidebarButton = () => {

  // HOOKS
  const { record: { new_used } = {} } = useRecordContext() || {};

  // RENDER
  return !!new_used && (
    <Sidebar.Button
      name="convertSidebar"
      label="Convert"
      icon="compare-arrows"
      outline
      fullWidth={false}
      size="sm"
  />
  )
}
ConvertSidebar.Button = ConvertSidebarButton;

// EXPORT
export default ConvertSidebar;
